import React from 'react';
import './../index.css'; // Import the CSS file for styling


const Loader = () => {
  return (
    <div className='flex'>
    <div className="loader-contain">
      <div className="loader-line" style={{ animationDelay: '0s' }} />
      <div className="loader-line" style={{ animationDelay: '0.2s' }} />
      <div className="loader-line" style={{ animationDelay: '0.4s' }} />
    </div>
  </div>
  );
}

export default Loader;
